import { LocalAccessRoles } from './types';

export const CAPTCHA_TOKEN_KEY = 'captchaToken';

export const ALL_ACCESS_ROLES = [LocalAccessRoles.AUTHORIZED, LocalAccessRoles.ANONYMOUS];
